export function splitNames(names){
  return names.split("\n").map(name => name.trim()).filter(name => name)
}



// WEBPACK FOOTER //
// ./src/services/issue4login.js